import {
    ConfigProvider,
    Layout, Row,
    theme,
    Typography,
} from 'antd';
import {useTranslation} from 'react-i18next';
import {Helmet} from 'react-helmet';
import {config, getCookie} from './helpers';
import React from 'react';
import enUS from 'antd/locale/en_US';
import etEE from 'antd/locale/et_EE';
import fiFI from "antd/locale/fi_FI";
import {BackgroundObject, BackgroundObject2, BackgroundObject3, Logo} from "./icons";
import {useResizeEffect} from "./resize-effect";

const {Content, Footer} = Layout;
const {defaultAlgorithm, darkAlgorithm} = theme;

const PublicPageLayout = ({children}) => {
    const defaultLang = getCookie('lang');
    const isDarkMode = false;
    const {t} = useTranslation();
    const backgroundImages = [BackgroundObject, BackgroundObject2, BackgroundObject3]

    const getDefaultLang = () => {
        if (defaultLang === 'et') {
            return etEE;
        }

        if (defaultLang === 'fi') {
            return fiFI;
        }

        return enUS;
    }

    return (
        <ConfigProvider
            locale={getDefaultLang()}
            theme={isDarkMode ? {
                algorithm: darkAlgorithm,
                token: {
                    colorLinkHover: "#2fc4b5",
                    colorLinkActive: "#2fc4b5",
                    colorPrimary: "#0EB8AE",
                    colorLink: "#0EB8AE",
                    fontSize: 14,
                    colorBgLayout: "#141414",
                    fontFamily: "Nunito, sans-serif",
                    fontSizeLG: 14,
                    boxShadowTertiary: "0 0 0 1px rgba(253, 253, 253, 0.12)",
                    Button: {
                        borderRadius: 12,
                        borderRadiusLG: 24,
                    }
                },
            } : {
                algorithm: defaultAlgorithm,
                token: {
                    colorLinkHover: "#2fc4b5",
                    colorLinkActive: "#2fc4b5",
                    colorPrimary: "#0EB8AE",
                    colorLink: "#0EB8AE",
                    fontSize: 14,
                    colorBgLayout: "white",
                    fontFamily: "Nunito, sans-serif",
                    fontSizeLG: 14,
                    boxShadowTertiary: "0 4px 15px #eaeff1",
                    Button: {
                        borderRadius: 12,
                        borderRadiusLG: 24,
                    }
                },
            }}
        >
            <Layout className="fitlap-layout">
                <Helmet>
                    <html lang={config('lang')}/>
                    <title>Fitlap</title>
                </Helmet>

                <Content className="fitlap-content">
                    <img src={backgroundImages[0]} alt="" draggable="false" className={`decorative-image image-one`}/>

                    <img src={backgroundImages[1]} alt="" draggable="false" className={`decorative-image image-two`}/>

                    {children}
                </Content>

                <Footer className="fitlap-footer">
                    {t('footer.copyright')}
                </Footer>
            </Layout>
        </ConfigProvider>
    );
};

export default PublicPageLayout;
